import React, { useCallback } from "react";
import { Tooltip, Select } from "antd";
import { useIntl } from "react-intl";

import "../index.css";

const { OptGroup, Option } = Select;

function ProductSelect({ selectedProduct, productGroups, onProductSelect }) {
  const intl = useIntl();
  const handleProductChange = useCallback(
    (productId) => {
      productGroups.map((group) =>
        group[1].map(
          (product) => product.id === productId && onProductSelect(product)
        )
      );
    },
    [onProductSelect, productGroups]
  );

  return (
    <Tooltip
      title={intl.formatMessage({
        id: "consignment.product.chosenProduct",
        defaultMessage: "Vámi vybraný produkt zásilky",
      })}
    >
      <Select
        onChange={handleProductChange}
        className="product-choice-select"
        placeholder={intl.formatMessage({
          id: "consignment.product.choose",
          defaultMessage: "Vyberte produkt zásilky",
        })}
        defaultValue={selectedProduct && selectedProduct.id}
      >
        {productGroups.map((g, i) => (
          <OptGroup label={g[0]} key={i}>
            {g[1].map((p, j) => (
              <Option value={p.id} key={j}>
                <Tooltip title={p.description} placement="bottom">{p.name}</Tooltip>
              </Option>
            ))}
          </OptGroup>
        ))}
      </Select>
    </Tooltip>
  );
}

export default ProductSelect;
